import type { SelectItem } from '@vrplatform/components';
import { Icon } from '@vrplatform/icons';
import { Tooltip } from '@mantine/core';
import { sortBy } from '@vrplatform/utils';
import type { RequestQuery } from '../api';
import { getBankAccountCategoryDetails } from './useAccountsQuery.utils';

type BankAccountSelectOptionAccount = {
  id: string;
  name?: string | null;
  status?: 'active' | 'inactive' | null;
  type?: 'bank' | 'ledger' | 'recurringFee' | 'nonPosting' | null;
  banking?: {
    category?: 'trust' | 'operating' | 'external' | null;
    last4?: string | null;
  } | null;
};

export function getBankAccountSelectOptionsQuery(): RequestQuery<'get:/accounts'> {
  return {
    limit: 200,
    status: 'active',
    type: 'bank',
  };
}

export function getBankAccountSelectOptions(
  accounts: BankAccountSelectOptionAccount[],
  OPEX: boolean
): SelectItem[] {
  return sortBy(
    accounts
      .filter((account) => {
        const status = account.status ?? 'active';
        const type = account.type ?? 'bank';

        return status === 'active' && type === 'bank';
      })
      .map<SelectItem>((account) => {
        const categoryDetails = getBankAccountCategoryDetails(
          account.banking?.category
        );
        const icon = categoryDetails ? (
          <Tooltip key={account.id} label={categoryDetails.label}>
            <Icon icon={categoryDetails.icon} size={16} />
          </Tooltip>
        ) : undefined;

        return {
          label: `${account.name || '-'} (${account.banking?.last4 || '-'})`,
          value: account.id,
          ...(icon && OPEX ? { icon } : {}),
        };
      }),
    'label'
  );
}
